import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

import { MSAL_CONFIG } from './msal.config';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(MSAL_CONFIG);
}
